module.exports = __webpack_public_path__ + "media/spiral-1280.9dd3a93d.mp4";